import { Button, ConfigProvider, Flex, Form, Layout, Menu, Result, Space, Spin, Steps, Typography, message, theme } from 'antd'
import React, { useEffect, useState } from 'react'
import Header from '../../components/header/Header'
import { LoadingOutlined } from '@ant-design/icons'
import Footer from '../../components/footer/Footer'
import companyService from '../../services/companyService'
import questionnaireService from '../../services/questionnaireService'
import { useNavigate, useParams } from 'react-router-dom'
import GenerateQuestionFields from '../../components/questionnaire/GenerateQuestionFields'
import Collapse from '../../components/collapse/Collapse'
import ScoreCard from '../../components/questionnaire/score-card/ScoreCard'
import { ReactComponent as Book } from '../../assets/questionnaire/book.svg'
import { ReactComponent as Message } from '../../assets/questionnaire/message-text.svg'
import { DomainsContext } from '../../contexts/DomainsContext'
const { Content, Sider } = Layout


const MATURITY = {
  0: 'uninitiated',
  1: 'learner',
  2: 'explorer',
  3: 'transformative',
  4: 'professional',
}

const indexName = {
  'genai': 'Gen AI'
}


const Review = () => {

  const {
    token: { colorBgContainer, borderRadiusLG, colorPrimary },
  } = theme.useToken();

  const { companyId, readinessIndexType } = useParams()

  const [isInitialRender, setIsInitialRender] = useState(true);

  const [companyData, setCompanyData] = useState({})
  const [domainsData, setDomainsData] = useState([])
  const [currentDomain, setCurrentDomain] = useState({})
  const [currentDimensionsData, setCurrentDimensionsData] = useState([])
  const [currentDimension, setCurrentDimension] = useState({})
  const [scores, setScores] = useState([])
  const [responses, setResponses] = useState([])
  const [dimensionScore, setDimensionScore] = useState({})
  const [domainScore, setDomainScore] = useState({})
  const [isDone, setIsDone] = useState(false)

  const [currentStep, setCurrentStep] = useState(0)
  const [doneDimensionIds, setDoneDimensionIds] = useState([])

  const [tabsLoading, setTabsLoading] = useState(true)
  const [responsesLoading, setResponsesLoading] = useState(true)
  const [companyLoading, setCompanyLoading] = useState(true)

  const [error, setError] = useState(false)
  const [responsesError, setResponsesError] = useState(false)

  const [messageApi, contextHolder] = message.useMessage();
  const [form] = Form.useForm()
  const navigate = useNavigate()


  const updateDimension = ({ domain, dimensionIndex }) => {
    const currentDimensionsData = domain.dimensions.map(({ id, title }) => ({ id, title }))

    setCurrentDimensionsData(currentDimensionsData)
    setCurrentDimension({ dimensionId: currentDimensionsData[dimensionIndex].id, dimensionIndex })
  }



  const displayResponses = () => {

    if(currentDomain.domainIndex === domainsData.length-1 && currentDimension.dimensionIndex === currentDimensionsData.length-1) {
      setIsDone(true)
    }
    else {
      setIsDone(false)
    }

    const domId = currentDomain.domainId
    const dimId = currentDimension.dimensionId

    const domainResponses = scores.find(obj => obj.domainId === domId);
    const dimensionResponses = domainResponses?.dimensionScores.find(obj => obj.dimensionId === dimId)

    
    const initialValues = {}
    const responses = dimensionResponses?.responses.map((item) => {

      const { normalizeScore, response, question: questionData  } = item
      const { type, id, question  } = questionData

      if(type === 'list') {
        response.split('$').forEach((item, index) => {
          initialValues[`list-${id}-${index}`] = item
        })
      }
      initialValues[id] = type === 'checkbox' ? (response ? response.split('$') : []) : (type === 'binary' ? (response === 'true') : (type === 'text' ? response : null))

      return {
        id,
        question,
        type,
        answer: response,
        normalizedScore: normalizeScore,
      }
      
    })
    
    setDomainScore({ score: domainResponses?.domainScore, maturityLevel: domainResponses?.maturityLevel })
    setDimensionScore({ score: dimensionResponses?.dimensionScore, maturityLevel: dimensionResponses?.maturityLevel })
    setResponses(responses)
    form.setFieldsValue(initialValues)

  }



  //this useEffect hook skips initial render and runs when currentDimension changes
  useEffect(() => {
    if (!isInitialRender) {
      
      displayResponses()
    }
  }, [isInitialRender, currentDimension]);


  useEffect(() => {
    companyService.getCompanyById(companyId)
      .then((response) => {
        setCompanyData(response.data)
      })
      .catch((error) => console.log(error))
      .finally(() => setCompanyLoading(false))


    questionnaireService.getDomains(readinessIndexType)
      .then((response) => {
        const domainsData = response.data.map(({ id, title, dimensions }) => ({ id, title, dimensions }))
        setDomainsData(domainsData)

        const domIndex = 0
        const dimIndex = 0

        setCurrentStep(domIndex)
        setCurrentDomain({ domainId: domainsData[domIndex].id, domainIndex: domIndex })

        updateDimension({ domain: domainsData[domIndex], dimensionIndex: dimIndex })

      })
      .catch((error) => {
        console.log(error)
        setError(true)
      })
      .finally(() => setTabsLoading(false))


    setResponsesLoading(true)
    questionnaireService.viewResponses(companyId, readinessIndexType)
      .then((response) => {
        setScores(response.data)

        const dimIds = []
        response.data?.forEach(({ dimensionScores }) => {
          dimensionScores?.forEach(({ dimensionId }) => {
            dimIds.push(dimensionId)
          })
        })
        setDoneDimensionIds(dimIds)

        setIsInitialRender(false)
      })
      .catch((error) => {
        console.log(error)
        setResponsesError(true)
      })
      .finally(() => setResponsesLoading(false))

  }, [])

  const handleNext = () => {
    window.scrollTo(0, 0)
    const currentDimIndex = currentDimension.dimensionIndex
    if(currentDimIndex < currentDimensionsData.length-1) {
      setCurrentDimension({ dimensionId: currentDimensionsData[currentDimIndex+1].id, dimensionIndex: currentDimIndex+1 })
    }
    else if(currentDimIndex === currentDimensionsData.length-1) {

      const currentDomIndex = currentDomain.domainIndex
      if(currentDomIndex < domainsData.length-1) {
        setCurrentDomain({ domainId: domainsData[currentDomIndex+1].id, domainIndex: currentDomIndex+1 })
        setCurrentStep(currentDomIndex+1)

        updateDimension({ domain: domainsData[currentDomIndex+1], dimensionIndex: 0 })
      }
    }
  }

  const handlePrevious = () => {
    window.scrollTo(0, 0)
    const currentDimIndex = currentDimension.dimensionIndex
    if(currentDimIndex > 0) {
      setCurrentDimension({ dimensionId: currentDimensionsData[currentDimIndex-1].id, dimensionIndex: currentDimIndex-1 })
    }
    else if(currentDimension.dimensionIndex === 0) {
      const currentDomIndex = currentDomain.domainIndex
      if(currentDomIndex > 0) {
        setCurrentDomain({ domainId: domainsData[currentDomIndex-1].id, domainIndex: currentDomIndex-1 })
        setCurrentStep(currentDomIndex-1)

        updateDimension({ domain: domainsData[currentDomIndex-1], dimensionIndex: domainsData[currentDomIndex-1].dimensions.length-1 })
      }
    }
  }

  const handleDone = () => {
    messageApi.open({
      type: 'loading',
      content: 'Redirecting...',
      duration: 0
    })
    setTimeout(() => {
      navigate('/companies')
    }, 2000)
  }

  return (
    <>
      {contextHolder}
      <Layout style={{minHeight: '100vh', minWidth: '1800px'}}>
        <Header bgColor={colorBgContainer}/>
        <Content
          style={{
            padding: '0 48px',
          }}
        >
          <Flex justify='space-between' style={{
            padding: 35,
            borderRadius: 15,
            backgroundColor: '#FFF',
            color: '#07224D',
            fontWeight: 700,
            marginTop: 35
          }}>
            <div style={{
              fontSize: 25,
            }}>Review - {indexName[readinessIndexType]}</div>
            <div style={{
              fontSize: 20,
            }}>
              {!companyLoading ? companyData?.companyName && `Company: ${companyData.companyName}` :
                <div style={{width: '150px', textAlign: 'center'}}><Spin indicator={<LoadingOutlined spin />} /></div>
              }
            </div>
          </Flex>
          {
            error ? <Result
              status="error"
              title="Error fetching data."
              extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
              }
            /> : (tabsLoading ?
            <Flex style={{ height: '300px', marginTop: 35, marginBottom: 35, borderRadius: 20, backgroundColor: '#FFF' }} align="center" justify="center">
              <Spin/>
            </Flex> :
            <>
              <Flex gap={35} style={{ marginTop: 35, marginBottom: 35, }}>
                {/* dimensions - sidebar */}
                <div style={{
                  background: colorBgContainer,
                  minHeight: 280,
                  padding: '35px 20px 30px 20px',
                  borderRadius: 25,
                  minWidth: 638,
                  alignSelf: 'flex-start'
                }}>
                  <div style={{
                    fontSize: '25px',
                    fontWeight: 700,
                    color: '#07224D',
                    marginBottom: 15
                  }}>Dimensions</div>
                  <DomainsContext.Provider value={{ currentDimension, currentDomain, doneDimensionIds }}>
                    <Flex vertical={true} gap={23}>
                      {domainsData.map((domainData, index) => <Collapse domainData={domainData} indexCount={index} />)}
                    </Flex>
                  </DomainsContext.Provider>
                </div>

                {/* main div */}
                <Flex vertical={true} gap={35} style={{ width: '100%' }}>

                  {/* score-card */}
                  <Flex gap={35}>
                    <ScoreCard icon={<Message/>} color='#8051F4' type='domain' score={domainScore.score} maturity={MATURITY[domainScore.maturityLevel]?.toUpperCase()}/>
                    <ScoreCard icon={<Book/>} color='#EC42B6' type='dimension' score={dimensionScore.score} maturity={MATURITY[dimensionScore.maturityLevel]?.toUpperCase()}/>
                  </Flex>

                  {/* questionnaire */}
                  <div style={{
                    backgroundColor: '#FFF',
                    borderRadius: 20,
                    padding: 30,
                    width: '100%'
                  }}>
                    <Flex vertical={true} gap={30} style={{
                      border: '1.5px solid #D7E3F1',
                      borderRadius: 10,
                      padding: '25px 30px 25px 30px'
                    }}>
                      {
                        responsesError ? <Result
                          status="error"
                          title="Error fetching Questions."
                          extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
                          }
                        /> : (responsesLoading ?
                        <Flex style={{height: '350px'}} align="center" justify="center">
                          <Spin indicator={<LoadingOutlined style={{ fontSize: 24, }} spin />}/>
                        </Flex> :
                        <>

                          {/* headings */}
                          <Flex vertical={true} gap={15}>
                            <div style={{
                              // font-family: Lato;
                              fontSize: '25px',
                              fontWeight: 700,
                              color: '#07224D',
                              lineHeight: '30px',
                              letterSpacing: '0em',
                            }}>{domainsData[currentDomain.domainIndex]?.title}</div>
                            <div style={{
                              // font-family: Lato;
                              fontSize: '20px',
                              fontWeight: 400,
                              lineHeight: '24px',
                              letterSpacing: '0em',
                              color: '#92A7BE',
                            }}>{currentDimensionsData[currentDimension.dimensionIndex]?.title}:</div>
                          </Flex>

                          {/* questions */}
                          <ConfigProvider theme={{
                            token: {
                              colorTextDisabled: '#000'
                            }
                          }}>
                            <Form 
                              // wrapperCol={{ span: 16 }}
                              style={{ display: 'flex', flexDirection: 'column', gap: 30 }}
                              form={form}
                              disabled={true}
                            >
                              <Flex vertical={true} gap={24}>
                                {responses?.map((questionData) => <GenerateQuestionFields key={questionData.id} questionData={questionData}/>)}
                              </Flex>
                              <Form.Item style={{ margin: 0 }}>
                                <Flex gap={20} justify='flex-end'>
                                  {!(currentDomain.domainIndex === 0 && currentDimension.dimensionIndex === 0) &&
                                    <Button type='default' disabled={false} htmlType='button' onClick={handlePrevious}>Previous</Button>
                                  }
                                  <Button type='default' disabled={false} onClick={isDone ? handleDone : handleNext} htmlType='button'>{isDone ? 'Done' : 'Next'}</Button>
                                </Flex>
                              </Form.Item>
                            </Form>
                          </ConfigProvider>
                          
                        </>)
                      }
                    </Flex>
                  </div>
                </Flex>
              </Flex>
            </>)
          }
          {/* <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 36,
              borderRadius: borderRadiusLG,
              marginTop: 16
            }}
          >
            <Space style={{justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
              <Typography.Title>
                Review
              </Typography.Title>
              <Typography.Title level={5}>
                {!companyLoading ? companyData?.companyName && `Company: ${companyData.companyName}` :
                  <div style={{width: '150px', textAlign: 'center'}}><Spin indicator={<LoadingOutlined spin />} /></div>
                }
              </Typography.Title>
            </Space>
            {
              error ? <Result
                status="error"
                title="Error fetching data."
                extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
                }
              /> : (tabsLoading ?
              <Flex style={{height: '150px'}} align="center" justify="center">
                <Spin/>
              </Flex> :
              <>
                <Steps
                  style={{ marginTop: 48 }}
                  current={currentStep}
                  items={domainsData.map(({ title }, index) => ({ title: `Domain ${index+1}`, description: title }))}
                />
                <Layout
                  style={{
                    marginTop: 48,
                    // border: '1px solid black',
                    padding: '24px 0',
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                  }}
                >
                  <Sider
                    style={{
                      background: colorBgContainer,
                    }}
                    width={250}
                  >
                    <Menu
                      mode="inline"
                      selectedKeys={[`${currentDimension.dimensionId}`]}
                      selectable={false}
                      style={{
                        height: '100%',
                        // marginTop: 64,
                      }}
                      items={[
                        {
                          key: 'dimensions',
                          label: 'Dimensions',
                          type: 'group',
                          children: currentDimensionsData.map(({ id, title }) => ({ key: `${id}`, label: title }))
                        }
                      ]}
                    />
                  </Sider>
                  <Content
                    style={{
                      padding: '0 24px',
                      minHeight: 280,
                    }}
                  >
                    {
                      responsesError ? <Result
                        status="error"
                        title="Error fetching Responses."
                        extra={<Button type="primary" onClick={() => window.location.reload()}>Reload</Button>
                        }
                      /> : (responsesLoading ?
                      <Flex style={{height: '350px'}} align="center" justify="center">
                        <Spin indicator={<LoadingOutlined style={{ fontSize: 24, }} spin />}/>
                      </Flex> :
                      <>
                        
                        <Space style={{justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
                          <Typography.Title style={{marginTop: 0}} level={1}>{domainsData[currentDomain.domainIndex]?.title}</Typography.Title>
                          <Typography.Title style={{marginTop: 0, color: colorPrimary}} level={5}>
                            Domain Score: {domainScore.score}
                            <span style={{marginLeft: '10px'}}>Maturity: {MATURITY[domainScore.maturityLevel]?.toUpperCase()}</span>
                          </Typography.Title>
                        </Space>
                        
                        <Space style={{justifyContent: 'space-between', alignItems: 'flex-start', width: '100%'}}>
                          <Typography.Title style={{marginTop: 0}} level={3}>{currentDimensionsData[currentDimension.dimensionIndex]?.title}:</Typography.Title>
                          <Typography.Title style={{marginTop: 0, color: colorPrimary}} level={5}>
                            Dimension Score: {dimensionScore.score}
                            <span style={{marginLeft: '10px'}}>Maturity: {MATURITY[dimensionScore.maturityLevel]?.toUpperCase()}</span>
                          </Typography.Title>
                        </Space>




                        <ConfigProvider theme={{
                          token: {
                            colorTextDisabled: '#000'
                          }
                        }}>
                          <Form wrapperCol={{ span: 16 }} style={{marginTop: 48}}
                            form={form}
                            disabled={true}
                          >
                            {responses?.map((questionData) => <GenerateQuestionFields key={questionData.id} questionData={questionData}/>)}
                            <Form.Item>
                              <Space>
                                {!(currentDomain.domainIndex === 0 && currentDimension.dimensionIndex === 0) &&
                                  <Button type='default' disabled={false} htmlType='button' onClick={handlePrevious}>Previous</Button>
                                }
                                <Button type='default' disabled={false} onClick={isDone ? handleDone : handleNext} htmlType='button'>{isDone ? 'Done' : 'Next'}</Button>
                              </Space>
                            </Form.Item>
                          </Form>
                        </ConfigProvider>
                      </>)
                    }
                  </Content>
                </Layout>
              </>)
            }
          </div> */}
        </Content>
        <Footer/>
      </Layout>
    </>
  )
}

export default Review
